const en = {
  common: {
    back: 'Back',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    saving: 'Saving...',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    loading: 'Loading...',
    noData: 'No data',
    error: 'Operation failed',
    success: 'Success',
    retry: 'Retry',
    more: 'More',
    all: 'All',
    search: 'Search',
    close: 'Close',
    publish: 'Publish',
    publishing: 'Publishing...',
    anonymous: 'Anonymous',
    author: 'Author',
    reply: 'Reply',
    share: 'Share',
    follow: 'Follow',
    followed: 'Following',
    followSuccess: 'Followed',
    unfollowSuccess: 'Unfollowed',
    bookmarked: 'Bookmarked',
    unbookmarked: 'Unbookmarked',
    linkCopied: 'Link copied',
    loginRequired: 'Please log in first',
    imageTooLarge: 'Image must be under 5MB',
    imageUploadFailed: 'Image upload failed',
    commentSent: 'Comment sent',
    replySent: 'Reply sent',
    commentFailed: 'Comment failed, please retry',
    publishSuccess: 'Published ✨',
    publishFailed: 'Publish failed',
    unknownError: 'Unknown error',
    uploadFailed: 'Upload failed',
    avatarUpdated: 'Avatar updated',
    preferencesUpdated: 'Preferences updated',
    saveFailed: 'Save failed',
  },
  nav: {
    home: 'Home',
    discover: 'Discover',
    create: 'Create',
    messages: 'Messages',
    profile: 'Profile',
  },
  discover: {
    pageTitle: 'AI Services',
    self: 'Me',
    add: 'Add',
    setupProfile: 'Create Your Profile',
    setupProfileHint: 'Add birth info to unlock personalized insights',
    bannerTitle: '"Explore the threads of your story."',
    bannerSubtitle: 'Discover your personal blueprint',
    bannerDesc: 'Select a profile to unlock personalized AI services. Get precise insights based on your personal data.',
    profilesTitle: 'Profiles',
    servicesTitle: 'AI Services',
    needProfileTitle: 'Profile Required',
    needProfileDescNoProfile: 'Please create your profile first to unlock personalized AI services.',
    needProfileDescSelectProfile: 'Please select a profile above before using AI services.',
    cancel: 'Cancel',
    goCreate: 'Create',
    ok: 'OK',
    services: {
      tarot: { title: 'CueCards', subtitle: 'Intuition Insights' },
      astrology: { title: 'StarScope', subtitle: 'Star Compass' },
      ziwei: { title: 'ZiweiLens', subtitle: 'Ziwei Analysis' },
      bazi: { title: 'BirthCode', subtitle: 'Birth Decode' },
      query: { title: 'QuantumAsk', subtitle: 'AI Quantum Chat' },
      travel: { title: 'CueGo', subtitle: 'Journey Advisor' },
      fengshui: { title: 'Space', subtitle: 'Space Harmony' },
      dream: { title: 'Dreams', subtitle: 'Dream Journal' },
    },
    mall: 'Gift Shop',
    mallComingSoon: '🛍️ Gift Shop coming soon, stay tuned',
    mallComingSoonDesc: 'Curated items for daily inspiration',
    prediction: 'Trending',
    predictionComingSoon: '🎯 Trending coming soon, stay tuned',
    predictionComingSoonDesc: 'Fun predictions, earn points rewards',
    serviceComingSoon: '✨ This feature is coming soon, stay tuned',
    serviceComingSoonDesc: 'We are working hard on development…',
  },
  home: {
    refreshing: 'Refreshing...',
    pullToRefresh: 'Release to refresh',
    dailyEnergy: 'Daily Energy',
    goSetup: 'Set up',
    more: 'More',
    setupDesc: 'Create your profile to unlock daily insights',
    setupCta: 'Unlock Your Insights',
    score: 'pts',
    calculating: 'Analyzing today\'s energy…',
    defaultTip: 'Feel the energy of the moment',
    dimLove: 'Love',
    dimWealth: 'Wealth',
    dimCareer: 'Career',
    dimStudy: 'Study',
    dimSocial: 'Social',
    recommend: 'For You',
    filterTitle: 'Filter Preferences',
    filterDesc: "Choose 3 topics you're interested in",
    filterSaving: 'Saving...',
    filterConfirm: 'Confirm',
    prefUpdated: 'Preferences updated',
    prefSaveFailed: 'Failed to save',
  },
  profile: {
    title: 'Profile',
    noNickname: 'No nickname set',
    editProfile: 'Edit Profile',
    viewHomepage: 'View Homepage',
    posts: 'Posts',
    followers: 'Followers',
    following: 'Following',
    likes: 'Likes',
    points: 'Points',
    pointsTip: 'Post or invite friends to earn points',
    invitation: 'Invite Friends',
    inviteBannerTitle: 'Invite & Earn',
    inviteBannerDesc: '+10 pts per invite',
    openVip: 'Get VIP',
    vipDesc: 'Unlock all premium features',
    vipNotOpen: 'Coming soon, stay tuned',
    myContent: 'My Content',
    postHistory: 'Post History',
    likesAndBookmarks: 'Likes & Bookmarks',
    browseHistory: 'Browse History',
    mysticalServices: 'AI Services',
    astroProfile: 'Personal Profile',
    dailyFortune: 'Daily Insights',
    settings: 'Settings',
    languageSwitch: 'Language',
    notifications: 'Notifications',
    notifOn: 'Enabled',
    notifOff: 'Disabled',
    notifAlreadyOn: 'Notifications are already enabled',
    notifGoSettings: 'Please enable notifications in system settings',
    notifEnabled: 'Notifications enabled',
    logout: 'Log Out',
    logoutConfirmTitle: 'Log Out',
    logoutConfirmDesc: 'You will need to log in again to continue. Are you sure?',
    deleteAccount: 'Delete Account',
    deleteAccountConfirmTitle: 'Delete Account',
    deleteAccountConfirmDesc: 'All your data will be permanently deleted and cannot be recovered. Are you sure?',
    deleteAccountSuccess: 'Account deleted',
    deleteAccountError: 'Failed to delete account, please try again',
    deleting: 'Deleting...',
    levelBronze: 'Bronze',
    levelSilver: 'Silver',
    levelGold: 'Gold',
    levelDiamond: 'Diamond',
    switchedTo: 'Switched to {{name}}',
    sessionExpired: 'Session expired, please log in again',
    phoneLogin: 'Phone login',
    emailLogin: 'Email login',
    accountInfo: 'Account Info',
    switchAccount: 'Switch Account',
    accountsCount: ' accounts',
    loginMethod: 'Login Method',
    accountDetails: 'Account Details',
    email: 'Email',
    phone: 'Phone',
    registeredAt: 'Registered',
    lastLogin: 'Last Login',
    feedback: 'Feedback',
    currentAccount: 'Current Account',
    otherAccounts: 'Other Accounts',
    online: 'Online',
    switchTo: 'Switch',
    switching: 'Switching',
    addAccount: 'Add Account',
  },
  languageDrawer: {
    title: 'Language',
    zhLabel: '简体中文',
    enLabel: 'English',
    confirmSwitch: 'Confirm',
  },
  editProfile: {
    title: 'Edit Profile',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Enter your nickname',
    bio: 'Bio',
    bioPlaceholder: 'Tell us about yourself...',
    userId: 'User ID',
    uploading: 'Uploading...',
    clickToChangeAvatar: 'Tap to change avatar',
    defaultAvatars: 'Presets',
    chooseAvatar: 'Choose a Default Avatar',
    customUpload: 'Custom',
    saveChanges: 'Save Changes',
    nicknameEmpty: 'Nickname cannot be empty',
    nicknameTooLong: 'Nickname cannot exceed 30 characters',
    nicknameTaken: 'This nickname is already taken',
    bioTooLong: 'Bio cannot exceed 200 characters',
    imageTooLarge: 'Image must be under 5MB',
    selectImage: 'Please select an image file',
    uploadFailed: 'Upload failed',
    avatarUpdated: 'Avatar updated',
    saveFailed: 'Save failed',
    profileUpdated: 'Profile updated',
  },
  myPosts: {
    title: 'My Posts',
    allRecords: 'All Posts',
    images: 'Images',
    videos: 'Videos',
    noContent: 'No posts yet',
    deleteFailed: 'Delete failed',
    deleted: 'Deleted',
    publishNew: 'New Post',
    postsCount: '{{count}} posts',
    deleteConfirmTitle: 'Delete Post',
    deleteConfirmDesc: 'This cannot be undone. Are you sure?',
  },
  likesBookmarks: {
    title: 'Likes & Bookmarks',
    liked: 'Liked',
    bookmarked: 'Bookmarked',
    noLikes: 'No liked content yet',
    noBookmarks: 'No bookmarked content yet',
  },
  browseHistory: {
    title: 'Browse History',
    noHistory: 'No browse history',
    clearFailed: 'Clear failed',
    cleared: 'History cleared',
    deletedPost: 'Deleted post',
    clearConfirmTitle: 'Clear History',
    clearConfirmDesc: 'This cannot be undone. Clear all browse history?',
  },
  social: {
    followers: 'Followers',
    following: 'Following',
    noFollowers: 'No followers yet',
    noFollowing: 'Not following anyone yet',
    followBack: 'Follow',
    follow: 'Follow',
    followed: 'Following',
    followSuccess: 'Followed',
    unfollowSuccess: 'Unfollowed',
  },
  search: {
    placeholder: 'Search content...',
    history: 'Search History',
    trending: 'Trending',
    noResults: 'No results found',
    tryOther: 'Try different keywords',
    searching: 'Searching...',
    views: 'views',
    noTrending: 'No trending data',
    matchTitle: 'Title',
    matchContent: 'Content',
    matchCategory: 'Category',
    matchTag: 'Tag',
  },
  login: {
    savedAccounts: 'Quick Login',
    continueGoogle: 'Continue with Google',
    continueGoogleLoading: 'Connecting to Google...',
    continueApple: 'Continue with Apple',
    continueAppleLoading: 'Connecting to Apple...',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    terms: 'By entering, you agree to our',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    quickAccess: 'Quick Access',
    demoAccount: 'Demo Account',
    quickAccessTitle: 'Quick Access',
    quickAccessDesc: 'Sign in with a demo account to explore the app',
    guestAccess: 'Guest Access',
    guestAccessDesc: 'Create a demo account and sign in instantly',
    testEnv: 'Test Environment',
    testEnvDesc: 'Choose a test account to enter',
    newUser: 'New User',
    newUserDesc: 'Fresh account, full onboarding',
    existingUser: 'Existing User',
    existingUserDesc: 'Account with existing data',
    loginFirstExisting: 'Log in as new user first',
    testLogging: 'Logging in...',
    testLoginFailed: 'Test login failed',
    googleNotEnabled: 'Google login not enabled, use email instead',
    googleLoginFailed: 'Google login failed',
    googleTimeout: 'Google login timed out, please retry',
    appleNotEnabled: 'Apple login not enabled',
    appleLoginFailed: 'Apple login URL generation failed',
    appleTimeout: 'Apple login timed out, please retry',
    loginSuccess: 'Login successful',
    signingIn: 'Signing in...',
    signInFailed: 'Sign in failed',
    signInSuccess: 'Signed in successfully',
    invalidRedirect: 'Invalid login redirect URL',
    or: 'OR',
    cancel: 'Cancel',
  },
  createPost: {
    publishImage: 'Image Post',
    publishVideo: 'Video Post',
    publish: 'Publish',
    publishing: 'Publishing...',
    titleLabel: 'Title',
    titlePlaceholder: 'Name your inspiration...',
    descLabel: 'Description',
    descPlaceholderImage: 'Share your thoughts and inspiration...',
    descPlaceholderVideo: 'Describe your video...',
    selectCategory: 'Category',
    categoryRequired: '*Required',
    tagNebula: 'Tag Nebula',
    exploreMore: 'Explore',
    collapse: 'Collapse',
    addImage: 'Add Image',
    clickSelectVideo: 'Select Video',
    videoSpec: 'MP4, MOV, max 200MB',
    coverOptional: 'Cover Image (optional)',
    addCover: 'Add Cover',
    videoTooLarge: 'Video must be under 200MB',
    videoSelectFailed: 'Failed to select video, please try again',
    selectCategoryPrompt: 'Please select a category',
    enterTitle: 'Please enter a title',
    addAtLeastOneImage: 'Add at least one image',
    addVideo: 'Please add a video',
    enterDesc: 'Please enter a description',
    selectAtLeastOneTag: 'Select at least one tag',
    maxTags: 'Max {{count}} tags allowed',
    customTagPlaceholder: 'Enter custom tag...',
    addTag: 'Add',
    searchTagPlaceholder: 'Search tags...',
    noMatchTag: 'No match, try adding a custom tag',
    noCommunityTag: 'No community tags yet',
    selectedCount: '{{selected}}/{{max}} tags selected',
    footer: 'Focus on creation · Inspiration forever',
    preparing: 'Preparing...',
    generatingCover: 'Generating cover...',
    uploadingVideo: 'Uploading video...',
    uploadingCover: 'Uploading cover {{current}}/{{total}}...',
    uploadingImage: 'Uploading image {{current}}/{{total}}...',
    posting: 'Publishing...',
    publishSuccess: 'Published ✨',
    publishFailed: 'Publish failed',
  },
  dailyFortune: {
    title: 'Daily Mood',
    refreshed: 'Insights updated ✨',
    refreshFailed: 'Update failed, try again later',
    aiSuggestion: 'CueGo Tips',
    love: 'Love',
    wealth: 'Wealth',
    career: 'Career',
    study: 'Study',
    social: 'Social',
    luckyColor: 'Lucky Color',
    luckyAccessory: 'Lucky Charm',
    luckyHour: 'Lucky Hour',
    luckyDirection: 'Direction',
    luckyNumbers: 'Numbers',
    luckyFood: 'Lucky Food',
    luckyFlower: 'Lucky Flower',
    wuxing: 'Wu Xing',
    defaultTip: 'Feel the energy of the moment',
    energyScore: 'ENERGY SCORE',
    luckMatrix: 'LUCK MATRIX',
    wisdomNote: 'Ancient wisdom from your BaZi reading',
    generating: 'Generating share image...',
    shareFailed: 'Share failed',
  },
  astroProfile: {
    title: 'Personal Profiles',
    myProfile: 'My Profile',
    associatedProfiles: 'Associated Profiles',
    noProfiles: 'No profiles yet',
    noProfilesDesc: 'Create your first profile to explore personalized insights',
    addNew: 'Add New Profile',
    self: 'Self',
    notSet: 'Not set',
    notSetNickname: 'No nickname',
    male: '♂ Male',
    female: '♀ Female',
    identitySelf: 'Self',
    identityBoyfriend: 'Boyfriend',
    identityGirlfriend: 'Girlfriend',
    identitySpouse: 'Spouse',
    identityFriend: 'Friend',
    identityParent: 'Parent',
    identityChild: 'Child',
    identitySibling: 'Sibling',
    identityColleague: 'Colleague',
    identityOther: 'Other',
  },
  astroDialog: {
    title: 'Profile Setup',
    subtitle: 'Personal Details',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Enter your nickname',
    relationship: 'Relationship',
    gender: 'Gender',
    genderRequired: 'Birth Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    single: 'Single',
    coupled: 'In a Relationship',
    married: 'Married',
    divine: 'Soul Mate',
    nonBinary: 'Non-binary',
    female: 'Female',
    male: 'Male',
    birthDatetime: 'Birth Date & Time',
    birthPlace: 'Birthplace',
    birthPlacePlaceholder: 'Enter city name',
    currentCity: 'Current City',
    currentCityPlaceholder: 'Enter city name',
    timezoneCalibration: 'Timezone',
    birthTimezone: 'Birth Timezone',
    tzChina: 'GMT +08:00 (China Standard Time)',
    tzGmt: 'GMT +00:00 (Greenwich Mean Time)',
    tzEst: 'GMT -05:00 (Eastern Standard Time)',
    daylightSaving: 'Daylight Saving',
    dstOn: 'DST correction enabled',
    dstOff: 'DST correction disabled',
    submit: 'Save Profile',
    submitting: 'Saving...',
    saved: 'Profile saved',
    footer: 'Complete your profile for personalized insights.',
    newProfile: 'New Profile',
    editProfile: 'Edit Profile',
    createProfile: 'Create Profile',
    saveChanges: 'Save Changes',
    profileCreated: 'Profile created',
    profileUpdated: 'Profile updated',
    profileDeleted: 'Profile deleted',
    deleteFailed: 'Delete failed',
    saveFailed: 'Save failed',
    selectGender: 'Please select birth gender',
    enterNickname: 'Please enter a nickname',
    selfExists: 'A "Self" profile already exists, only one allowed',
    selfSyncNote: 'Selecting "Self" syncs nickname to account, one per user',
    identityRelation: 'Identity Relation',
    selectIdentity: 'Select identity relation',
    selectIdentityTitle: 'Select Identity',
    alreadyExists: '(exists)',
    solar: 'Solar',
    lunar: 'Lunar',
    selectBirthTime: 'Select birth time',
    selectSolarTime: 'Select Solar Birth Time',
    selectLunarTime: 'Select Lunar Birth Time',
    lunarAutoConvert: 'Lunar dates are automatically converted to solar for storage',
    yearUnit: '',
    monthUnit: '',
    dayUnit: '',
    hourUnit: '',
    minuteUnit: '',
    confirmBtn: 'Confirm',
    selectTimezone: 'Select Timezone',
    selectLocation: 'Select',
    searchLocation: 'Search location...',
    allRegions: 'All',
    goBack: 'Go back',
    selectThis: 'Select "{{name}}"',
    noLocationMatch: 'No matching location',
    syncBirthPlace: 'Sync birthplace',
    newFooter: 'Create a new profile for personalized insights.',
    editFooter: 'Update your personal details.',
    identityPet: 'Pet',

    // Timezone labels
    tzJpKr: 'GMT +9 Japan/Korea',
    tzIndia: 'GMT +5:30 India',
    tzSea: 'GMT +7 Southeast Asia',
    tzMoscow: 'GMT +3 Moscow',
    tzEastEu: 'GMT +2 Eastern Europe',
    tzCentralEu: 'GMT +1 Central Europe',
    tzGreenwich: 'GMT +0 Greenwich',
    tzUsEast: 'GMT -5 US Eastern',
    tzUsCentral: 'GMT -6 US Central',
    tzUsMountain: 'GMT -7 US Mountain',
    tzUsWest: 'GMT -8 US Western',
    tzAuEast: 'GMT +10 Australia East',
    tzNz: 'GMT +12 New Zealand',
    tzChinaLabel: 'GMT +8 China',

    // Lunar month names
    lunarMonth1: 'Jan', lunarMonth2: 'Feb', lunarMonth3: 'Mar',
    lunarMonth4: 'Apr', lunarMonth5: 'May', lunarMonth6: 'Jun',
    lunarMonth7: 'Jul', lunarMonth8: 'Aug', lunarMonth9: 'Sep',
    lunarMonth10: 'Oct', lunarMonth11: 'Nov', lunarMonth12: 'Dec',
  },
  onboarding: {
    title: 'Choose your',
    titleHighlight: 'Interests',
    subtitle: 'Pick at least 3 categories for personalized recommendations',
    selectedCount: 'Selected {{count}}/3',
    continue: 'Continue',
    preferenceSaved: 'Preferences saved ✨',
    saveFailed: 'Save failed',
  },
  invitation: {
    title: 'Invite Friends',
    rules: 'Rules',
    myInviteCode: 'My Invite Code',
    codeCopied: 'Code copied',
    linkCopied: 'Link copied',
    shareText: 'Join MyCue community! Use my invite code {{code}} to sign up',
    earnedPoints: 'Earned {{points}}/{{max}} points',
    shareLink: 'Share Link',
    sharePoster: 'Share Poster',
    records: 'Invitation Records',
    noRecords: 'No invitations yet',
    maxReached: 'Max reached',
    rulesTitle: 'Invitation Rules',
    rule1: 'Each user has a unique invite code that can be shared via link, code, or poster',
    rule2: 'When a new user registers with your code, you earn 10 points',
    rule3: 'Maximum 100 points from invitations (10 people)',
    rule4: 'Invite codes can only be used once per new user during registration',
    posterSubtitle: 'Explore your personal world',
    posterBottom: 'Scan or use invite code to register',
    posterSaved: 'Poster saved',
    scanToJoin: 'Scan to join MyCue',
    savePoster: 'Save Poster',
    inviteCodeLabel: 'Invite Code (optional)',
    inviteCodePlaceholder: 'Enter invite code',
    inviteSuccess: 'Invite code applied',
    inviteAlreadyUsed: 'You have already used an invite code',
    inviteInvalid: 'Invalid invite code',
    inviteSelf: 'Cannot use your own invite code',
  },
  userProfile: {
    noPosts: 'No posts yet',
  },
  notFound: {
    title: '404',
    subtitle: 'Page Not Found',
    desc: 'The page you are looking for does not exist.',
    returnHome: 'Return Home',
  },
  levelInfo: {
    title: 'Cultivation Ranks',
    current: 'Current',
    startingLevel: 'Granted upon registration',
    pointsRequired: 'Requires {{points}} points to unlock',
    howToEarn: 'Earn +10 points per post (daily max 30), +10 per friend invited. Points can be used for AI services.',
    howToEarnXp: 'Each point spent on AI services earns 1 XP. Approved posts earn 10 XP. Level up automatically when your XP reaches the threshold.',
    maxLevel: '🎉 Max level reached!',
    currentPoints: 'Current: {{points}} pts',
    currentXp: 'Current {{xp}}',
    pointsRemaining: '{{points}} points to next level',
    xpRemaining: '{{xp}} XP to next level',
  },
  points: {
    title: 'My Points',
    currentBalance: 'Current Balance',
    balanceDesc: 'Points can be used for AI services',
    recharge: 'Top Up',
    earnRules: 'How to Earn',
    rulePost: 'Publish Posts',
    rulePostDesc: 'Earn 10 points per post published',
    rulePostLimit: 'Daily max 30 points from posts',
    ruleInvite: 'Invite Friends',
    ruleInviteDesc: 'Earn 10 points for each friend invited',
    ruleInviteLimit: 'Max 100 points from invitations (10 people)',
    history: 'Transaction History',
    noHistory: 'No transactions yet',
    rechargeTitle: 'Top Up Points',
    rechargeDesc: 'Top-up feature coming soon, stay tuned',
    selectPlan: 'Select a Plan',
    pointsUnit: 'pts',
    bestValue: 'Best Deal',
    popular: 'Popular',
    superValue: 'Great Value',
    buyNow: 'Buy Now',
    purchasing: 'Purchasing...',
    purchaseSuccess: 'Success! {{points}} points added',
    purchaseFailed: 'Purchase failed, please try again',
    purchaseFailedDesc: 'If this persists, restart the app or contact support',
    productNotAvailable: 'Product unavailable',
    productNotAvailableDesc: 'This product is not yet available, please try later',
    networkError: 'Network error',
    networkErrorDesc: 'Please check your connection and try again',
    paymentNotAllowed: 'Payment not allowed',
    paymentNotAllowedDesc: 'Payment is restricted on this device or account',
    webPrice: 'Web Price',
    iosPrice: 'iOS Price',
    perPoint: '~{{price}} / point',
    paymentPending: 'Payment Coming Soon',
    paymentPendingDesc: 'Payment integration is being set up, please check back later',
    billingNotReady: 'Payment service loading',
    billingNotReadyDesc: 'Please try again later. If the issue persists, restart the app.',
    nativeOnly: 'Purchase in App',
    nativeOnlyDesc: 'Points can only be purchased within the iOS / Android app',
    alreadyProcessed: 'This transaction has already been processed',
  },
  comment: {
    comments: 'Comments',
    noComments: 'No comments yet, be the first ✨',
    viewAll: 'View all {{count}} comments',
    hot: 'Hot',
    new: 'Latest',
    replyTo: 'Reply to',
    replyPlaceholder: 'Reply to @{{name}}...',
    inputPlaceholder: 'Share your thoughts...',
    sayPlaceholder: 'Say something...',
  },
  postDetail: {
    publishedAt: 'Published',
    reads: 'reads',
    notFoundTitle: 'Content lost in stardust',
    notFoundDesc: 'This post may have been deleted or never existed',
    backToExplore: 'Back to Explore',
    bookmark: 'Save',
    commentPlaceholder: 'Share your thoughts...',
    imageTooLarge: 'Image must be under 5MB',
    imageUploadFailed: 'Image upload failed',
    imageLabel: '[Image]',
  },
  phone: {
    title: 'Phone Verification',
    desc: 'We will send a verification code to your phone to confirm your identity.',
    placeholder: 'Enter phone number',
    sendCode: 'Get Code',
    resend: 'Resend',
    resendCountdown: 'Resend ({{count}}s)',
    enterOtp: 'Enter 6-digit code',
    verifying: 'Verifying...',
    confirmLogin: 'Confirm Login',
    otpSent: 'Code sent',
    loginSuccess: 'Login successful!',
    phoneDisabled: 'Phone login not enabled, use email or Google',
    enterPhone: 'Enter phone number',
    selectCountry: 'Select Country/Region',
    searchCountry: 'Search country or code...',
    noResults: 'No results found',
  },
  categoryFilter: {
    title: 'Filter Preferences',
    subtitle: 'Choose 3 categories you\'re interested in',
    confirmPreferences: 'Confirm Preferences',
  },
  timeAgo: {
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
  },
  messages: {
    title: 'Messages',
    likes: 'Likes',
    comments: 'Comments',
    system: 'System',
    noNotifications: 'No messages yet',
    justNow: 'Just now',
    today: 'Today',
    yesterday: 'Yesterday',
    likedYourPost: 'liked your post',
    commentedOnPost: 'commented on your post',
    repliedToComment: 'replied to your comment',
    earnedPostPoints: 'Your post was published, earned points',
    earnedInvitePoints: 'Friend invitation successful, earned points',
    systemNotification: 'System notification',
    pts: 'pts',
    markAllRead: 'Mark all read',
    allMarkedRead: 'All marked as read',
    noUnread: 'No unread messages',
    deleteFailed: 'Delete failed',
    emptyLikes: 'No one has liked your posts yet',
    emptyComments: 'No comments received yet',
    emptySystem: 'No system messages',
  },
  feedback: {
    title: 'Feedback',
    categoryBug: '🐛 Bug',
    categorySuggestion: '💡 Suggestion',
    categoryUi: '🎨 UI',
    categoryOther: '💬 Other',
    placeholder: 'Describe the issue or suggestion...',
    addScreenshot: 'Add Screenshot',
    maxScreenshots: 'Maximum {{count}} screenshots',
    screenshotFailed: 'Screenshot upload failed',
    submit: 'Submit',
    submitFailed: 'Submit failed, please retry',
    thankYou: 'Thanks for your feedback!',
  },
  forceUpdate: {
    title: 'New Version Available 🚀',
    currentVersion: 'Current version',
    noLongerSupported: 'is no longer supported',
    pleaseUpdate: 'Please update to',
    toContinue: 'to continue',
    updateNow: 'Update Now',
  },
  conversation: {
    title: 'Conversations',
    newChat: 'New Chat',
    noRecords: 'No conversations yet',
    justNow: 'Just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
  },
  dataSource: {
    label: 'Combine data sources (multi-select)',
    selectSource: 'Select source',
    allData: 'All data combined',
    combinedWith: 'Combined: {{sources}}',
    noSelect: 'None',
    selectAll: 'Select All',
    collapse: 'Collapse',
    bazi: 'Bazi',
    astrology: 'Astrology',
    ziwei: 'Zi Wei',
  },
  aiCommon: {
    generating: 'Generating share image...',
    imageSaved: 'Image saved',
    shareGenerated: 'Share image generated',
    generateFailed: 'Generation failed, please retry',
    shareFailed: 'Share failed, please retry',
    networkError: 'Network error, please retry',
    tooFrequent: 'Too many requests, please try later',
    insufficientPoints: 'Insufficient points, earn more first',
    aiQuotaExhausted: 'AI quota exhausted',
    aiFailed: 'AI reading failed',
    cannotReadStream: 'Cannot read stream',
    perUse: '/use',
    chartGenerated: '✨ Chart data generated and cached',
    energyRefreshed: '✨ Energy peaks refreshed',
    chartFailed: 'Chart generation failed, please retry',
    askAi: 'Ask AI',
    self: 'Self',
  },
  tarot: {
    aiReading: 'AI is reading your spread…',
    saveImage: 'Save Image',
    generatingImage: 'Generating…',
    imageSaved: 'Image saved',
    imageFailed: 'Image generation failed, please retry',
    copied: 'Reading copied',
    copyFailed: 'Copy failed',
    resetReading: 'New Reading',
  },
  insufficientPoints: {
    title: 'Insufficient Points',
    desc: 'This service requires {{required}} points, your balance is only {{current}} points.',
    hint: 'Post or invite friends to earn more points!',
    goEarn: 'Earn Points',
    inviteFriends: 'Invite Friends',
  },
  video: {
    share: 'Share',
    linkCopied: 'Link copied',
  },
  aiTarot: {
    pageTitle: 'CueCards',
    pageSubtitle: 'INTUITION INSIGHTS',
    loaderText: 'Gathering insight energy…',
    stepSpread: 'Spread',
    stepQuestion: 'Question',
    stepDraw: 'Draw',
    stepReading: 'Reading',
  },
  aiBazi: {
    pageTitle: 'BirthCode',
    noProfileMsg: 'Please create an astro profile with birth time first',
    missingBirthTime: 'Selected profile is missing birth time',
    createProfile: 'Create Profile',
    completeProfile: 'Complete Profile',
    selfLabel: 'Self',
    addProfile: 'Add New Profile',
    tabNatal: 'Natal',
    tabFlow: 'Flow',
    aiReading: 'AI Reading',
    mainStar: 'Star',
    dayMaster: 'Master',
    yearPillar: 'Year',
    monthPillar: 'Month',
    dayPillarMale: 'Male',
    dayPillarFemale: 'Female',
    hourPillar: 'Hour',
    tianGan: 'Stems',
    diZhi: 'Branches',
    hideGan: 'Hidden',
    diShi: 'Phase',
    ziZuo: 'Self-Seat',
    daYun: 'Decade',
    liuNian: 'Annual',
    liuYue: 'Monthly',
    naYin: 'Na Yin',
    kongWang: 'Void',
    diShiSection: 'Phase',
    diShiNote: '(12 Stages)',
    shenSha: 'Spirits',
    tianGanRel: 'Stem Relations',
    diZhiRel: 'Branch Relations',
    noTianGanRel: 'No stem combinations or clashes',
    noDiZhiRel: 'No branch combinations, clashes or penalties',
    ageUnit: 'y/o',
    startYun: 'luck start',
    yuanJu: 'Natal',
  },
  aiZiwei: {
    pageTitle: 'ZiweiLens',
    noProfileMsg: 'Please create an astro profile with birth time first',
    missingBirthTime: 'Selected profile is missing birth time',
    createProfile: 'Create Profile',
    completeProfile: 'Complete Profile',
    selfLabel: 'Self',
    addProfile: 'Add New Profile',
    aiReading: 'AI Reading',
    // Chart labels
    levelDecadal: 'Decade',
    levelYearly: 'Year',
    levelMonthly: 'Month',
    levelDaily: 'Day',
    levelHourly: 'Hour',
    levelLabelDecadal: 'Dec',
    levelLabelYearly: 'Yr',
    levelLabelMonthly: 'Mo',
    levelLabelDaily: 'Dy',
    levelLabelHourly: 'Hr',
    bodyLabel: 'Body',
    selfPalace: 'Self',
    oppositePalace: 'Opposite',
    trianglePalace: 'Trine',
    clearOverlay: 'Clear',
    ageUnit: 'y/o',
    currentLabel: 'Current',
    noDecadalData: 'No decade data',
    monthUnit: 'M',
    // Horoscope summary
    decadalLimit: 'Decade',
    yearlyFlow: 'Year',
    monthlyFlow: 'Month',
    dailyFlow: 'Day',
    hourlyFlow: 'Hour',
    decadalSiHua: 'Dec Si Hua',
    yearlySiHua: 'Yr Si Hua',
    // Palace detail
    bodyPalace: 'Body Palace',
    originPalace: 'Origin Palace',
    decadalRange: 'Decade {{stem}}{{branch}} · {{start}}~{{end}} y/o',
    siHuaTitle: 'Si Hua',
    majorStarsTitle: 'Major Stars',
    minorStarsTitle: 'Minor Stars',
    adjStarsTitle: 'Adj Stars',
    sanFangTitle: 'Trine & Opposite',
    patternEnergy: 'Pattern Energy',
    luDesc: 'Wealth',
    quanDesc: 'Power',
    keDesc: 'Fame',
    jiDesc: 'Obstacle',
    siHuaDistribution: 'Si Hua Distribution',
    decadalFlowStars: 'Decade Flow Stars',
    yearlyFlowStars: 'Yearly Flow Stars',
    twelveDeitiesTitle: '12 Deities',
    changsheng12: 'Changsheng 12',
    boshi12: 'Boshi 12',
    jiangqian12: 'Jiangqian 12',
    suiqian12: 'Suiqian 12',
    minorAgesTitle: 'Minor Ages',
    // Star types
    starTypeMajor: 'Major',
    starTypeSoft: 'Auspicious',
    starTypeTough: 'Malefic',
    starTypeTianma: 'Tianma',
    starTypeLucun: 'Lucun',
    starTypeFlower: 'Peach Blossom',
    starTypeHelper: 'Helper',
    starTypeAdj: 'Adjective',
    starDescMajor: 'Core energy of the palace',
    starDescSoft: 'Positive influence',
    starDescTough: 'Challenges & growth',
    starDescTianma: 'Movement & change',
    starDescLucun: 'Stable wealth',
    starDescFlower: 'Romance & popularity',
    starDescHelper: 'Auxiliary energy',
    starDescAdj: 'Fine-tune palace traits',
    // Brightness
    brightMiao: 'Temple',
    brightWang: 'Prosper',
    brightDe: 'Gain',
    brightLi: 'Favor',
    brightPing: 'Neutral',
    brightBu: 'Weak',
    brightXian: 'Fall',
    brightDescMiao: 'Star at peak, excellent expression',
    brightDescWang: 'Star strong, abundant energy',
    brightDescDe: 'Star grounded, normal expression',
    brightDescLi: 'Star favorable, slight benefit',
    brightDescPing: 'Star average, neutral',
    brightDescBu: 'Star displaced, limited expression',
    brightDescXian: 'Star fallen, more negative',
    // Mutagen labels
    mutagenLu: 'Lu · Wealth flows',
    mutagenQuan: 'Quan · Power gained',
    mutagenKe: 'Ke · Fame rises',
    mutagenJi: 'Ji · Obstacles arise',
    // Relation config
    relationTriangle: 'Trine',
    relationOpposite: 'Opposite',
    relationTriangleDesc: 'Support & resources',
    relationOppositeDesc: 'Complement & opposition',
    // Star meanings
    starZiwei: 'Emperor star, strong leadership, noble & proud',
    starTianji: 'Wisdom star, strategic, intellectual, restless',
    starTaiyang: 'Sun star, noble, generous, suits public service',
    starWuqu: 'Wealth star, resolute, good with finances',
    starTiantong: 'Fortune star, gentle, content, lacks drive',
    starLianzhen: 'Peach blossom star, clever, competitive, versatile',
    starTianfu: 'Treasury star, steady, conservative, practical',
    starTaiyin: 'Moon star, gentle, good finances, emotional',
    starTanlang: 'Peach blossom major, versatile, desire-driven, social',
    starJumen: 'Shadow star, eloquent, prone to disputes, analytical',
    starTianxiang: 'Seal star, refined, helpful, dependent',
    starTianliang: 'Shade star, upright, turns misfortune, worrisome',
    starQisha: 'General star, bold, pioneering, lone fighter',
    starPojun: 'Destruction star, driven, breaks old to build new',
    starZuofu: 'Noble helper, good rapport, strong support',
    starYoubi: 'Noble aide, covert assistance, benefactor luck',
    starWenchang: 'Academic star, intelligent, literary talent',
    starWenqu: 'Arts star, versatile, romantic, peach blossom',
    starTiankui: 'Yang noble, daytime benefactors, male patrons',
    starTianyue: 'Yin noble, nighttime benefactors, female patrons',
    starQingyang: 'Punishment star, fierce, driven, injury risk',
    starTuoluo: 'Hidden drain, delays, repetition, covert losses',
    starHuoxing: 'Fire star, impulsive, explosive, fast rise/fall',
    starLingxing: 'Bell star, restless, covert force, sudden change',
    starDikong: 'Void star, transcendent, suits religion/art',
    starDijie: 'Robbery star, sudden upheaval, suits technical work',
    starLucunStar: 'Steady wealth, thrifty, conservative',
    starTianmaStar: 'Travel star, movement & development abroad',
    starHongluan: 'Romance star, love & celebration',
    starTianxi: 'Joy star, marriage & good rapport',
    starXianchi: 'Peach blossom, strong opposite-sex attraction',
    starTianyao: 'Charm star, magnetic appeal, secret romance',
    starTianxing: 'Punishment star, suits law/military',
    starTianku: 'Sorrow star, emotional, suits artistic creation',
    starTianxu: 'Vanity star, outwardly grand, inwardly empty',
    starLongchi: 'Talent star, artistic flair, refined taste',
    starFengge: 'Elegance star, cultured, aesthetic eye',
    starTiancai: 'Genius star, gifted, quick understanding',
    starTianshou: 'Longevity star, healthy, cheerful',
    starTianguan: 'Official star, suits government career',
    starTianfu2: 'Blessing star, fortunate, comfortable life',
    starTianchu: 'Kitchen star, food luck, suits F&B industry',
    starEnguang: 'Grace star, elder blessings, promotion luck',
    starTiangui: 'Noble aura, high social standing',
    starSantai: 'Support star, helpful, step-by-step progress',
    starBazuo: 'Authority star, dignified, respected',
    starTaifu: 'Support star, backing, covert noble help',
    starFenggao: 'Honor star, accolades, merit expected',
    starJieshen: 'Relief star, turns misfortune, resolves trouble',
    starTianwu: 'Mystic star, intuitive, suits metaphysics',
    starHuagai: 'Solitary talent, brilliant but aloof, suits religion',
    starGuchen: 'Lone star, independent, solitary nature',
    starGuasu: 'Widow star, love difficulties, suits late marriage',
    starFeilian: 'Gossip star, disputes, hidden adversaries',
    starPosui: 'Fracture star, many twists, imperfect',
    starTiankong2: 'Fantasy star, imaginative, impractical',
    starJiekong: 'Cutoff star, interruptions, starts strong ends weak',
    starXunkong: 'Void star, hollow, fame without substance',
    starTianshang: 'Injury star, prone to harm, be careful',
    starTianshi: 'Messenger star, serves others, selfless',
    starYinsha: 'Hidden harm, covert attacks, beware',
    starTianyue2: 'Illness star, weak constitution, mind health',
    starYuede: 'Virtue star, kind-hearted, saved in disaster',
    starTiande: 'Great virtue, upright, fortune in misfortune',
    // Center panel
    yang: 'Yang',
    yin: 'Yin',
    male: 'Male',
    female: 'Female',
    // Hour labels
    hour_zi: 'Zi (23-1)',
    hour_chou: 'Chou (1-3)',
    hour_yin: 'Yin (3-5)',
    hour_mao: 'Mao (5-7)',
    hour_chen: 'Chen (7-9)',
    hour_si: 'Si (9-11)',
    hour_wu: 'Wu (11-13)',
    hour_wei: 'Wei (13-15)',
    hour_shen: 'Shen (15-17)',
    hour_you: 'You (17-19)',
    hour_xu: 'Xu (19-21)',
    hour_hai: 'Hai (21-23)',
  },
  aiAstrology: {
    pageTitle: 'StarScope',
    selectProfile: 'Select Profile',
    selfLabel: 'Self',
    addProfile: 'Add New Profile',
    readingChart: 'Reading your chart...',
    selectToView: 'Select a profile to view chart reading',
    energyPeaks: 'Energy Peaks',
    energyPeaksEn: 'ENERGY PEAKS',
    recalculate: 'Refresh',
    love: 'Love',
    career: 'Career',
    wealth: 'Wealth',
    social: 'Social',
    luck: 'Luck',
    wisdom: 'Wisdom',
    emotion: 'Emotion',
    intellect: 'Intellect',
    health: 'Health',
    creativity: 'Creativity',
    inputPlaceholder: 'Any wealth advice for this year?',
  },
  aiTravel: {
    pageTitle: 'CueGo',
    selectProfile: 'Select Profile',
    selfLabel: 'Self',
    addProfile: 'Add New Profile',
    greeting: '"The energy of time and space is flowing, traveler seeking guidance."',
    energyTitle: 'Current Travel Energy Alignment',
    alignment: 'Alignment',
    energyDesc: 'Energy field shows today\'s {{direction}} direction has significant energy boost potential. Best travel window is {{hour}}.',
    loadingEnergy: 'Loading today\'s energy data…',
    loadingHint: 'Generate daily insights on the home page first',
    luckyDir: '🧭 Lucky Dir: {{value}}',
    luckyHour: '🕐 Lucky Hour: {{value}}',
    luckyColor: '🎨 Lucky Color: {{value}}',
    luckyItem: '💎 Lucky Item: {{value}}',
    guidedTitle: 'Guided Conversations',
    q1: 'How should I plan my travel based on lucky directions?',
    q2: 'What route should I take to avoid today\'s misfortune?',
    q3: 'Is today better for traveling or staying home?',
    q4: 'What time should I go out to boost wealth luck?',
    q5: 'What lucky item should I carry when traveling?',
    inputPlaceholder: 'Ask about your travel...',
    streaming: 'Sensing space-time energy…',
  },
  aiQuery: {
    pageTitle: 'QuantumAsk',
    selectProfile: 'Select Profile',
    selfLabel: 'Self',
    addProfile: 'Add New Profile',
    greeting: 'Hello, I am the Star Realm Guide. Everything has its destiny and variables. What aspect would you like to explore today?',
    q1: 'How is my wealth luck recently?',
    q2: 'Any advice on my current love life?',
    q3: 'Is there a turning point in my career?',
    q4: 'What is today\'s inspiration index?',
    inputPlaceholder: 'Ask anything...',
    streaming: 'Analyzing your insights…',
  },
  tarotSpread: {
    chooseSpread: 'Choose Your Spread',
    title: 'Select Spread',
    cardsUnit: 'cards',
    bottomHint: 'Tap a spread to begin your divination',
  },
  tarotQuestion: {
    customLabel: 'Free Ask',
    customDesc: 'Ask what\'s on your mind',
    dailyLabel: 'Daily',
    dailyDesc: 'Today\'s energy guidance',
    monthlyLabel: 'Monthly',
    monthlyDesc: 'This month\'s energy trend',
    yearlyLabel: 'Yearly',
    yearlyDesc: 'Annual outlook',
    customQ1: 'What changes will my love life see recently?',
    customQ2: 'Should I persist or pivot in my career?',
    customQ3: 'How is my wealth luck lately?',
    customQ4: 'How can I improve my relationships?',
    dailyQ1: 'What should I watch out for today?',
    dailyQ2: 'How is today\'s love energy?',
    dailyQ3: 'Is today good for important decisions?',
    dailyQ4: 'Where is my lucky direction today?',
    monthlyQ1: 'How will my career develop this month?',
    monthlyQ2: 'Will there be a turning point in love this month?',
    monthlyQ3: 'How is the financial outlook this month?',
    monthlyQ4: 'Where should I focus this month?',
    yearlyQ1: 'How is the overall outlook this year?',
    yearlyQ2: 'Will there be a career breakthrough this year?',
    yearlyQ3: 'Will there be major changes in love this year?',
    yearlyQ4: 'What should I pay most attention to this year?',
    defaultCustom: 'Please guide my path',
    defaultDaily: 'Read my daily energy',
    defaultMonthly: 'Read my monthly outlook',
    defaultYearly: 'Read my yearly outlook',
    inputHint: 'Enter or select a question',
    quickSelect: 'Quick Select',
    back: 'Back',
    startDraw: 'Start Drawing',
    customPlaceholder: 'Clear your mind...write your question',
    fortunePlaceholder: 'What do you want to ask about {{mode}}?',
  },
  tarotReading: {
    yourQuestion: 'Your Question',
    destinyTitle: 'Destiny Revelation',
    aiReadingDesc: 'AI-powered deep insight analysis',
    reversed: 'Reversed',
    retryHint: 'Please retry later or try a different question',
    notLoggedIn: 'Not logged in',
    readingFailed: 'Reading failed',
    positionFallback: 'Position {{index}}',
    shareTitle: 'CueCards Insight',
    historyFallback: 'CueCards Insight',
  },
  tarotDeck: {
    preloadText: 'Preparing the ritual, please focus…',
    preloadSubtext: 'Stabilizing the insight field',
    shuffling: 'Shuffling',
    shuffleHint: 'Clear your mind, feel the cards\' energy',
    selectPrompt: 'Follow your intuition, pick card {{current}} / {{total}}',
    gatherTitle: 'Spread Complete',
    gatherHint: 'The cards of destiny are gathering...',
    revealTitle: 'Revealing destiny...',
    cardsUnit: ' cards',
  },
  ziweiCenter: {
    beijingTime: 'Beijing Time',
    lunarTime: 'Lunar Date',
    solarPillars: 'Solar Pillars',
    soulMaster: 'Soul Master',
    bodyMaster: 'Body Master',
    soulPalace: 'Soul Palace',
    bodyPalace: 'Body Palace',
    ziYearDou: 'Zi Year Ruler',
    selfTransform: 'Self Transform',
    oppositeIn: 'Opposite In',
    siHuaColors: 'Si Hua Colors',
    lu: 'Lu',
    quan: 'Quan',
    ke: 'Ke',
    ji: 'Ji',
  },
  aiHistory: {
    title: 'Usage History',
    all: 'All',
    noRecords: 'No records yet',
    retentionNote: 'Records kept for 6 months',
    deleted: 'Deleted',
    spread: 'Spread',
    profile: 'Profile',
    viewHistory: 'History',
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: February 24, 2026',
    s1Title: '1. Information We Collect',
    s1Intro: 'We collect the following types of information:',
    s1AccountLabel: 'Account Information:',
    s1Account: 'Email address, phone number, display name, and profile picture when you create an account.',
    s1OAuthLabel: 'OAuth Data:',
    s1OAuth: 'When you sign in via Google, we receive your name, email, and profile photo as authorized by you.',
    s1ContentLabel: 'User Content:',
    s1Content: 'Posts, comments, likes, and bookmarks you create within the App.',
    s1UsageLabel: 'Usage Data:',
    s1Usage: 'Information about how you interact with the App, including pages visited and features used.',
    s1DeviceLabel: 'Device Information:',
    s1Device: 'Device type, operating system, and browser type.',
    s2Title: '2. How We Use Your Information',
    s2a: 'To provide, maintain, and improve the App',
    s2b: 'To personalize your experience, including daily fortune readings',
    s2c: 'To communicate with you about updates and new features',
    s2d: 'To detect, prevent, and address security issues',
    s2e: 'To comply with legal obligations',
    s3Title: '3. Data Storage & Security',
    s3Body: 'Your data is stored securely on Supabase infrastructure with encryption at rest and in transit. We implement industry-standard security measures including Row-Level Security (RLS) policies to ensure users can only access their own data. We do not sell your personal information to third parties.',
    s4Title: '4. Data Sharing',
    s4Intro: 'We do not sell, trade, or rent your personal information. We may share data only in the following circumstances:',
    s4a: 'With your consent',
    s4b: 'To comply with legal requirements or respond to lawful requests',
    s4c: 'To protect our rights, privacy, safety, or property',
    s4d: 'In connection with a merger, acquisition, or sale of assets',
    s5Title: '5. Your Rights',
    s5Intro: 'You have the right to:',
    s5a: 'Access your personal data',
    s5b: 'Correct inaccurate data',
    s5c: 'Delete your account and associated data',
    s5d: 'Export your data in a portable format',
    s5e: 'Opt out of non-essential communications',
    s6Title: '6. Cookies & Tracking',
    s6Body: 'The App uses essential cookies and local storage for authentication and session management. We do not use third-party tracking cookies for advertising purposes.',
    s7Title: '7. Children\'s Privacy',
    s7Body: 'The App is not intended for users under the age of 13. We do not knowingly collect personal information from children under 13. If we discover that a child under 13 has provided us with personal information, we will delete it promptly.',
    s8Title: '8. Changes to This Policy',
    s8Body: 'We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy within the App. Your continued use after changes are posted constitutes acceptance of the revised policy.',
    s9Title: '9. Contact Us',
    s9Body: 'If you have questions or concerns about this Privacy Policy, please contact us at',
  },
  terms: {
    title: 'Terms of Service',
    lastUpdated: 'Last updated: February 24, 2026',
    s1Title: '1. Acceptance of Terms',
    s1Body: 'By accessing or using MyCue ("the App"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the App.',
    s2Title: '2. Description of Service',
    s2Body: 'MyCue is a community-driven platform that provides mystical and metaphysical content, including but not limited to daily fortune readings, zodiac insights, and user-generated posts. All content is for entertainment and informational purposes only and should not be considered professional advice.',
    s3Title: '3. User Accounts',
    s3Body: 'You must create an account to access certain features. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must provide accurate and complete information during registration.',
    s4Title: '4. User Content',
    s4Body: 'You retain ownership of content you post on MyCue. By posting content, you grant MyCue a non-exclusive, worldwide, royalty-free license to use, display, reproduce, and distribute your content within the App. You agree not to post content that is illegal, harmful, threatening, abusive, defamatory, or otherwise objectionable.',
    s5Title: '5. Prohibited Conduct',
    s5a: 'Impersonating any person or entity',
    s5b: 'Harassing, bullying, or intimidating other users',
    s5c: 'Posting spam, unsolicited advertisements, or malicious content',
    s5d: 'Attempting to gain unauthorized access to the App or its systems',
    s5e: 'Using the App for any unlawful purpose',
    s6Title: '6. Intellectual Property',
    s6Body: 'All trademarks, logos, and service marks displayed on the App are the property of MyCue or their respective owners. You may not use any of these without prior written permission.',
    s7Title: '7. Disclaimer of Warranties',
    s7Body: 'The App is provided "as is" and "as available" without warranties of any kind, either express or implied. MyCue does not warrant that the App will be uninterrupted, error-free, or free of viruses or other harmful components.',
    s8Title: '8. Limitation of Liability',
    s8Body: 'To the fullest extent permitted by law, MyCue shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the App.',
    s9Title: '9. Modifications',
    s9Body: 'MyCue reserves the right to modify these Terms at any time. We will notify users of significant changes. Your continued use of the App after such modifications constitutes acceptance of the updated Terms.',
    s10Title: '10. Contact',
    s10Body: 'If you have any questions about these Terms, please contact us at',
  },
  moderation: {
    title: 'More Options',
    reportTitle: 'Report Content',
    reportContent: 'Report this content',
    reportContentDesc: 'Report if this content violates community guidelines',
    blockUser: 'Block {{name}}',
    blockUserDesc: 'You will no longer see content from this user',
    reportSuccess: 'Report submitted. We will review within 24 hours.',
    reportFailed: 'Failed to submit report',
    blockSuccess: 'Blocked {{name}}',
    blockFailed: 'Failed to block user',
    submitReport: 'Submit Report',
    descriptionPlaceholder: 'Additional details (optional)',
    reason_spam: 'Spam',
    reason_harassment: 'Harassment',
    reason_inappropriate: 'Inappropriate',
    reason_violence: 'Violence',
    reason_fraud: 'Fraud',
    reason_other: 'Other',
  },
};

// Auto-generated English translations
export default en;
